import React, { useEffect, useState } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../i18n"; // important to import
function AICertificate() {
    const { t } = useTranslation("Certificate");
    const location = useLocation();
    const navigate = useNavigate();
    const [result, setResult] = useState({
        grade: "",
        pdf: "",
    });

    useEffect(() => {
        if (location?.state?.grade) {
            setResult(location.state);
        } else {
            navigate("/sign-in");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Header />
            <section className="py-5">
                <div className="container">
                    <div
                        className={`row certificate_card justify-content-center`}
                    >
                        <div className="col-xl-6">
                            <div className="card border-0 question_card_box px-0">
                                <img
                                    src="/featured-courses/girl-party.jpg"
                                    alt=""
                                />
                                <div className="card-body">
                                    <h6>{t("youpassedscore")} </h6>
                                    <h4>{result.grade}</h4>
                                </div>
                            </div>
                            <div>
                                <div className="d-flex justify-content-end pt-4 pb-md-5">
                                    <Link
                                        to="/free-trail/whats-open"
                                        state={{
                                            step: true,
                                            trailId: location?.state?.trailId,
                                            name: location?.state?.name,
                                            userData: location?.state?.userData,
                                        }}
                                        className="btn-explore p-sm-15 d-flex justify-content-between align-items-center gap-3 rounded-2 mt-md-4"
                                    >
                                        {t("proceed")}
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={22}
                                            height={14}
                                            viewBox="0 0 22 14"
                                            fill="none"
                                            className="ms-5"
                                        >
                                            <path
                                                d="M1 6.99854H21L16 1"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M21 6.99805L16 12.9995"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                            />
                                        </svg>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default AICertificate;
